define('shared/my/efid',['shared/util/state'], function(state){
    var KEY = 'session.efid';
    return {
        set: function (id) {
            return state.push(KEY, id);
        },
        get: function () {
            return state.get(KEY).then(function(values){
                return values[0];
            });
        }
    };
});
